export const DROPPABLE_INDEX_TO_FIELD = 0

export const DROPPABLE_INDEX_CC_FIELD = 1

export const DROPPABLE_INDEX_BCC_FIELD = 2
